(() => {
  const initialize = (root) => {
    const sections = [...root.querySelectorAll('[data-fw27-collection]')];
    if (root.matches?.('[data-fw27-collection]')) sections.unshift(root);
    sections.forEach((section) => {
      if (section.dataset.fw27CollectionReady === 'true') return;
      const controls = section.querySelector('[data-fw27-collection-controls]');
      const images = [...section.querySelectorAll('[data-fw27-collection-image]')];
      const buttons = [...section.querySelectorAll('[data-fw27-collection-view]')];
      const status = section.querySelector('[data-fw27-collection-status]');
      if (!controls || !images.length || buttons.length < 2) return;
      section.dataset.fw27CollectionReady = 'true';
      controls.hidden = false;
      buttons.forEach((button) => button.addEventListener('click', () => {
        if (button.getAttribute('aria-pressed') === 'true') return;
        const view = button.dataset.fw27CollectionView;
        if (!['front', 'back', 'female', 'male'].includes(view)) return;
        const label = button.textContent.trim();
        images.forEach((image) => {
          const source = image.dataset[`${view}Src`];
          if (!source) return;
          image.removeAttribute('srcset');
          image.src = source;
          image.alt = `${image.dataset.productTitle} — ${label}`;
        });
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        section.dataset.fw27CollectionView = view;
        if (status) status.textContent = label;
      }));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
